// Operator-confirmed September 15, 2026. Engraving terms, not laser cutting.
const laserEngravingFacts = {
  path: '/laser-engraving-service-nyc/',
  nationalPath: '/services/laser-engraving/',
  metalPath: '/services/metal-engraving/',
  metalProcess: 'MOPA laser',
  reviewedDate: '2026-09-15',
  setupFee: 75,
  productionRanges: [
    { label: 'Small items', price: '$10–$25 per piece' },
    { label: 'Medium items', price: '$45–$65 per piece' },
    { label: 'Large items', price: '$100+ per piece' },
  ],
  workAreas: { metal: '8 × 8 inches', wood: '48 × 36 inches' },
  standardLeadTime: '2–3 weeks',
}

const engravingAreaAnswer = `PrintAWorld’s metal engraving area is up to ${laserEngravingFacts.workAreas.metal}; wood engraving is up to ${laserEngravingFacts.workAreas.wood}. These are engraving areas, not maximum object dimensions. The object’s shape, coating, height, and access to the artwork placement still need review. Ask us about the available area for other materials.`
const engravingTimingAnswer = `Standard laser-engraving lead time at PrintAWorld is ${laserEngravingFacts.standardLeadTime}. Suitable rush projects may be ready as soon as the next day or within a week, subject to project review and availability. For a rush request, be ready to send or drop off your items the same day the job is confirmed. Transit time affects what is possible; confirm the in-hand date with us before sending anything.`
const engravingPriceAnswer = `PrintAWorld charges a $${laserEngravingFacts.setupFee} setup fee plus per-piece engraving. Typical production ranges are $10–$25 for small items, $45–$65 for medium items, and $100+ for large items. These are planning ranges, not fixed rates or total job prices. Item size, engraving area, quantity, complexity, and rush requirements affect the quote. Small, medium, and large are quoting categories, not fixed dimensional bands.`
const engravingFaqs = [
  {
    question: 'How much does laser engraving in NYC cost?',
    answer: engravingPriceAnswer,
  },
  {
    question: 'How long does laser engraving take? Can you rush my project?',
    answer: engravingTimingAnswer,
  },
  {
    question: 'How large an area can you engrave on metal or wood?',
    answer: engravingAreaAnswer,
  },
  {
    question:
      'Is laser engraving the right choice for a solid black or full-color logo?',
    answer:
      'Not always. An engraved or laser-marked result depends on the material and coating. If you need an opaque black or full-color graphic on an approved aluminum item, metal card, or other object, <a href="/uv-printing-services/">UV printing</a> may be a better fit. Send a photo and the finish you want so we can recommend the process.',
  },
]

module.exports = {
  laserEngravingFacts,
  engravingAreaAnswer,
  engravingTimingAnswer,
  engravingPriceAnswer,
  engravingFaqs,
}
